import React, { Component } from "react";
import EmailEditor from "react-email-editor";
import { connect } from "react-redux";
import { Form, Spin } from "antd";
import { Redirect } from "react-router-dom";
import _ from "lodash";
import push from "react-router-redux";
import {
  withFirestore,
  firestoreConnect,
  isLoaded,
  isEmpty
} from "react-redux-firebase";
import { compose } from "redux";

import CampaignForm from "./CampaignForm";
import {
  CampaignField as Fields,
  SendTestEmailFields as EmailFields
} from "../common/labels/forms";
import EmailTemplate from "./EmailTemplate";
import AddRecipient from "./AddRecipient";
import { columns } from "../common/labels/tables";
import { sendCampaign, onDraft, deleteCampaign } from "../../actions/campaign";
import Campaigns from "./Campaigns";
import { Container } from "semantic-ui-react";
import CustomTemplate from "./CustomTemplate";
import firebase from "firebase";

class index extends Component {
  state = {
    open: false,
    removeCampaign: false,
    selected_count: 0,
    page: 1,
    start_count: 0,
    project: {
      recipients: {}
    },
    minValue: 0,
    maxValue: 10,
    searchRecipients: ""
  };

  confirm = () => this.onDeleteCampaign(this.state.removeCampaign);

  onOpen = campaign => this.setState({ open: true, removeCampaign: campaign });

  onClose = () => this.setState({ open: false });

  handleChange = value => {
    if (value <= 1) {
      this.setState({
        minValue: 0,
        maxValue: 10
      });
    } else {
      this.setState({
        minValue: this.state.maxValue,
        maxValue: value * 10
      });
    }
  };

  onDeleteCampaign = campaign => {
    const { deleteCampaign } = this.props;
    deleteCampaign(campaign.id);
    this.onClose();
  };

  sendEmail = () => {
    this.props.sendCampaign(this.state.project, this.props.history);
  };

  saveDraft = () => {
    this.props.onDraft(this.state.project, this.props.history);
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          page: 3,
          project: values
        });
      }
    });
  };

  onCreateCampaignForm = () => {
    this.setState({
      page: 3
    });
  };

  onChangePage = (event, data) => {
    const { activePage } = data;

    if (activePage !== this.state.page) {
      this.setState({ page: activePage });
    }
  };

  changePage = page => {
    this.props.dispatch(push("/?page=" + page));
  };

  handleSearch = event => {
    this.setState({
      searchRecipients: event.target.value.substr(0, 20)
    });
  };

  onCustomTemplate = () => {
    this.setState({
      page: 2
    });
  };

  onCancel = () => {
    this.setState({ page: this.state.page - 1 });
  };

  onSendTestCampaign = e => {
    e.preventDefault();
    const campaign = firebase.functions().httpsCallable("sendTestCampaign");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        campaign({
          email: values,
          subject: this.state.project.subject,
          html: this.state.project.html
        });
      }
      this.props.form.resetFields();
    });
  };

  editDraft = campaign => {
    this.setState({
      page: 4,
      project: {
        ...this.state.project,
        subject: campaign.subject,
        title: campaign.title,
        userId: campaign.userId,
        id: campaign.id,
        design: campaign.design
      }
    });

    if (this.editor !== undefined && this.editor !== null) {
      this.editor.loadDesign(JSON.parse(this.state.project.design));
    } else {
      setTimeout(
        () => this.editor.loadDesign(JSON.parse(this.state.project.design)),
        4000
      );
    }
  };

  loadCustomTemplate = campaign => {
    this.setState({
      page: 4,
      testemail: [],
      project: {
        ...this.state.project,
        userId: this.state.userId,
        design: campaign
      }
    });

    if (this.editor !== undefined && this.editor !== null) {
      this.editor.loadDesign(JSON.parse(campaign));
    } else {
      setTimeout(() => this.editor.loadDesign(JSON.parse(campaign)), 4000);
    }
  };

  loadTemplate = () => {
    this.setState({
      page: 4
    });

    if (this.editor !== undefined && this.editor !== null) {
      this.editor.loadDesign(this.state.project.design);
    } else {
      setTimeout(() => this.editor.loadDesign(this.state.project.design), 4000);
    }
  };

  onShowTemplateTools = values => {
    this.setState({
      page: 3,
      project: values
    });
  };

  blankTemplate = () => {
    this.setState({
      page: 4
    });
  };

  saveTemplate = () => {
    this.editor.exportHtml(data => {
      const { design, html } = data;
      this.setState({
        page: 5,
        project: {
          ...this.state.project,
          userId: this.props.auth.uid,
          design,
          html,
          recipients: {}
        }
      });
    });
  };

  componentWillUnmount() {
    this.saveDraft();
  }

  renderContent() {
    if (this.state.page === 4) {
      return (
        <EmailTemplate
          onCancel={this.onCancel}
          saveTemplate={this.saveTemplate}
          emailTools={
            <EmailEditor
              ref={editor => (this.editor = editor)}
              minHeight={"87vh"}
              appearance={{
                theme: "light",
                panels: {
                  tools: {
                    dock: "left"
                  }
                }
              }}
            />
          }
          reloadTemplate={this.state.project}
        />
      );
    }

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        const recip = _.map(selectedRows, "email");
        this.setState({
          selected_count: selectedRows.length,
          project: { ...this.state.project, recipients: recip }
        });
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        if (selected) {
          const recip = _.map(this.props.recipients, "email");
          this.setState({
            project: { ...this.state.project, recipients: recip },
            selected_count: recip.length
          });
        }
      }
    };

    const filteredRecipients =
      this.props.recipients &&
      this.props.recipients.filter(content => {
        const recip = Object.keys(content);

        return recip.some(
          key =>
            content[key]
              .toString()
              .toLowerCase()
              .indexOf(this.state.searchRecipients) !== -1
        );
      });

    if (!isLoaded(this.props.auth)) {
      return (
        <div style={{ marginTop: 100, textAlign: "center" }}>
          <Spin size="large" />
        </div>
      );
    }

    if (isEmpty(this.props.auth)) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        {this.state.page === 1 && (
          <Campaigns
            editDraft={this.editDraft}
            onOpen={this.onOpen}
            onClose={this.onClose}
            campaigns={this.props.campaigns}
            onDeleteCampaign={this.onDeleteCampaign}
            modalState={this.state.open}
            confirm={this.confirm}
            error={this.props.error}
            handleChange={this.handleChange}
            state={this.state}
            onCustomTemplate={this.onCustomTemplate}
          />
        )}
        {this.state.page === 3 && (
          <CustomTemplate
            blankTemplate={this.blankTemplate}
            templates={this.props.templates}
            onCreateCampaignForm={this.onCreateCampaignForm}
            loadCustomTemplate={this.loadCustomTemplate}
            onCancel={this.onCancel}
          />
        )}
        {this.state.page === 2 && (
          <CampaignForm
            value={this.state.project}
            showTemplateTools={this.onShowTemplateTools}
            Fields={Fields}
            getFieldDecorator={this.props.form.getFieldDecorator}
            isFieldTouched={this.props.form.isFieldTouched}
            getFieldsError={this.props.form.getFieldsError}
            handleSubmit={this.handleSubmit}
          />
        )}
        {this.state.page === 5 && (
          <AddRecipient
            saveDraft={this.saveDraft}
            sendEmail={this.sendEmail}
            project={this.state.project}
            url={this.props.match.url}
            rowSelection={rowSelection}
            onChangePage={this.onChangePage}
            onChange={this.onChange}
            columns={columns}
            auth={this.props.auth}
            state={this.state}
            selectedCount={this.state.selected_count}
            loadTemplate={() => this.loadTemplate(this.state.project.design)}
            recipients={filteredRecipients}
            handleSearch={this.handleSearch}
            EmailFields={EmailFields}
            getFieldDecorator={this.props.form.getFieldDecorator}
            isFieldTouched={this.props.form.isFieldTouched}
            getFieldsError={this.props.form.getFieldsError}
            onSendTestCampaign={this.onSendTestCampaign}
          />
        )}
      </Container>
    );
  }

  render() {
    return <div>{this.renderContent()}</div>;
  }
}

const mapStateToProps = ({ firestore, firebase, campaigns }) => {
  return {
    recipients: firestore.ordered.recipients,
    auth: firebase.auth,
    campaigns: firestore.ordered.campaigns,
    campaignAlert: campaigns,
    templates: firestore.ordered.templates,
    error: campaigns
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sendCampaign: campaign => dispatch(sendCampaign(campaign, ownProps)),
    onDraft: draft => dispatch(onDraft(draft, ownProps)),
    deleteCampaign: campaign => dispatch(deleteCampaign(campaign, ownProps))
  };
};

const WrappedIndex = Form.create({ name: "campaign" })(index);

export default compose(
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  firestoreConnect(props => {
    return [
      {
        collection: "recipients",
        where: [["userId", "==", props.auth.uid || null]]
      },
      {
        collection: "campaigns",
        where: [["userId", "==", props.auth.uid || null]]
      },
      {
        collection: "templates"
      }
    ];
  })
)(WrappedIndex);
